import React from 'react'
import { Container } from 'react-bootstrap'
import Address from '../Components/Address/Address'


function Contact() {
    return (
        <Container id="contact" >
         <Address/>
      </Container>
    )
}

export default Contact
